import React from "react";
import { CreateRouter, routeHooks } from 'router'

const AppRoutes = () => {
    const routes = routeHooks.useAppRoutes()

    return (
        <CreateRouter routes={routes} />
    );
}

export default AppRoutes
